export const PoemAlienSoil = () => {
    return (
        <div id="021" className="">
            <p>
                the panic shrieks out of the ground and starts out by feeling
                like
            </p>
            <p>the feet of a small insect on your skin,</p>
            <p>it's the outside world that wants to enter,</p>
            <p>waters, uncharted,</p>
            <p>tractor beams gleaming in the night, eye contact with</p>
            <p>the eye of the storm,</p>
            <p>-</p>
            <p>how many walls are there between you and it?</p>
            <p>it's however many you want to put up -</p>
            <p>most often i find that i grow and shrink,</p>
            <p>contract / expand / fill out all available space,</p>
            <p>the air around us solidified,</p>
            <p>everything's a hypothesis,</p>
            <p>you've measured that the things </p>
            <p>you want to give to other people</p>
            <p>can't be packaged or carried or wrapped in anything,</p>
            <p>or be put into words,</p>
            <p>a bulwark in your mouth,</p>
            <p>a half-grin that looks like something else.</p>
            <p>yes, i stockpile my worries,</p>
            <p>yes, there is paint that is the color of fear,</p>
            <p>you paint with it crop circles on the planes of your skin.</p>
            <p>
                unless addressed, things have this tendency of etching
                themselves
            </p>
            <p>onto whatever's nearby,</p>
            <p>
                so there's a thin plastic-like film between me and the outside
                world,
            </p>
            <p>space suit i've thought up,</p>
            <p>i do everything with it in mind,</p>
            <p>i wash it when i wash my hands,</p>
            <p>so how do you</p>
            <p>make contact when you already</p>
            <p>inhabit the body like it were</p>
            <p>alien soil to begin with?</p>
        </div>
    );
};
